module.exports = __webpack_public_path__ + "img/mos-swiper-phone2.77fa6319.png";